<div class="d-flex flex-row flex-wrap gap-3 my-5 dad-single"
     [class.three-in-line]="question.answers_options.length < 4 && question.answers_options.length > 2">
  <div class="left-module bloc-resp-images flex-wrap gap-3">
    <div *ngFor="let resp of question.answers_options"
         [class.drag-disabled]="isDraggable(resp) == null"
         [attr.draggable]="isDraggable(resp)"
         (dragstart)="app.dragDropHelper.onDragStart($event, resp)"
         class="d-flex"
         [ngStyle]="{'background-image': 'url(' + resp.image + ')'}">
    </div>
  </div>

  <div class="right-module drop-area"
       *ngFor="let zone of drop_zones; let i = index"
       [class.drag-over]="zone.is_drag_over"
       (drop)="app.dragDropHelper.onDrop($event, drop_zones, i); onAnswerChange()"
       (dragover)="app.dragDropHelper.onDragOver($event, drop_zones, i)"
       (dragleave)="app.dragDropHelper.onDragLeave($event, drop_zones, i)">
    <div *ngIf="!zone.id" [innerHtml]="additional_text"></div>
    <div *ngIf="zone.id" [ngStyle]="{'background-image': 'url(' + zone.image + ')'}"></div>
  </div>
</div>
